/* Orthomen light section behaviours (announcement rotation). Idempotent. */
(function () {
  'use strict';
  if (window.__orthomenSectionsInit) return;
  window.__orthomenSectionsInit = true;

  function initAnnounce(root) {
    if (root.dataset.orthomenAnnounceInit) return;
    root.dataset.orthomenAnnounceInit = 'true';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-announce-item]'));
    var rotate = root.dataset.rotate === 'true';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!rotate || reduced || items.length < 2) return;
    var interval = parseInt(root.dataset.interval, 10) || 4000;
    var i = 0;
    function show(n) {
      items.forEach(function (el, idx) { el.style.display = idx === n ? '' : 'none'; });
    }
    show(0);
    root.orthomenTimer = window.setInterval(function () {
      if (root.dataset.paused === 'true') return;
      i = (i + 1) % items.length;
      show(i);
    }, interval);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-orthomen-announce-section]').forEach(initAnnounce);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-orthomen-announce-section]').forEach(function (el) {
      if (el.orthomenTimer) window.clearInterval(el.orthomenTimer);
    });
  });
  document.addEventListener('shopify:section:select', function (e) {
    var el = e.target.querySelector('[data-orthomen-announce-section]');
    if (el) el.dataset.paused = 'true';
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var el = e.target.querySelector('[data-orthomen-announce-section]');
    if (el) el.dataset.paused = 'false';
  });
})();
